import { FireAndFlowerCardData } from './fire-and-flower-card-data';

export class FireAndFlowerSalePriceCardData extends FireAndFlowerCardData {
  static copyFrom(cardData: FireAndFlowerCardData): FireAndFlowerSalePriceCardData {
    const copy = new FireAndFlowerSalePriceCardData();
    copy?.copyFrom(cardData);
    return copy;
  }

  public readonly showRegularPriceAtBottom: boolean = true;
}
